import { z } from 'zod';

export const VALID_GRADERS = ['psa', 'bgs', 'cgc', 'sgc'] as const;
export type ValidGrader = (typeof VALID_GRADERS)[number];

const CGC_AUTH_TITLE_PATTERN = /cgc\W*auth/i;

export const normalizeGrader = (grader: string | undefined, title?: string): ValidGrader => {
    const normalizedGrader = grader?.trim().toLowerCase();
    if (!normalizedGrader) return 'psa';

    if (normalizedGrader === 'mba') return 'sgc';

    if (normalizedGrader === 'cgc' && CGC_AUTH_TITLE_PATTERN.test(title ?? '')) {
        return 'sgc';
    }

    if ((VALID_GRADERS as readonly string[]).includes(normalizedGrader)) {
        return normalizedGrader as ValidGrader;
    }
    console.warn(`Unsupported grader "${grader}". Falling back to "psa".`);
    return 'psa';
};

export const graderWithFallback = z
    .string()
    .transform((grader) => normalizeGrader(grader))
    .optional();
